import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import { pageState } from 'State/page'
import {
  getChartDataAction,
  getMessageMinimumDetailsAction,
  getRecipientAction,
  getRecipientMessagesTotalCountersAction,
} from '../actions/actions'
import {
  chartState,
  recipientState,
  tableLoadingState,
  tableStateResult,
  tableStateSerach,
} from '../state/result'

// import {
//   storeGet
// } from 'mailup-react-helpers'

export const loadTrendDetailsCallback =
  ({ set }) =>
  async (Counters) => {
    if (Counters.TotalItems > 0) {
      Counters.TotalCounters.forEach(async (r, index) => {
        if (r.IdMessage) {
          const messageDetails = await getMessageMinimumDetailsAction(
            r.IdMessage,
          )

          set(tableStateResult, (prev) => ({
            ...prev,
            items: prev.items.map((m) =>
              m.IdMessage === r.IdMessage
                ? {
                    ...m,
                    ServiceType: messageDetails.ServiceType,
                    Subject: messageDetails.Subject,
                    Tag: messageDetails.Tag,
                    Note: messageDetails.Note
                      ? 'ID ' + r.IdMessage + ' - ' + messageDetails.Note
                      : 'ID ' + r.IdMessage,
                  }
                : m,
            ),
          }))
        } else {
          set(tableStateResult, (prev) => ({
            ...prev,
            items: prev.items.map((m) =>
              m.IdMessage === r.IdMessage
                ? {
                    ...m,
                    Subject: '-',
                  }
                : m,
            ),
          }))
        }
      })
    }
  }

export const getRecipientCallback =
  ({ set, snapshot, reset }) =>
  async (idRecipient) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      status: 'initial',
    }))

    const { pageSize, pageNumber, orderBy, orderDescending } =
      await snapshot.getPromise(tableStateSerach)

    try {
      const resp = await getRecipientAction(idRecipient)

      const { Counters } = await getRecipientMessagesTotalCountersAction(
        idRecipient,
        pageSize,
        pageNumber,
        orderBy,
        orderDescending,
        ['AT', 'CT'],
      )

      set(recipientState, (prev) => ({
        ...prev,
        recipientProfile: resp,
        channel: resp.Email ? 'email' : 'sms',
      }))

      set(tableStateResult, (prev) => ({
        ...prev,
        items:
          Counters.TotalItems > 0
            ? Counters.TotalCounters.filter((f) => f.IdMessage > 0)
            : [],
        totalItems: Counters.TotalItems,
      }))

      loadTrendDetailsCallback({ set })(Counters)

      set(pageState, (prev) => ({
        ...prev,
        status: 'ready',
      }))
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, {
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
        status: 'error',
      })
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false,
    }))
  }

export const laodTrendTableCallback =
  ({ set, snapshot, reset }) =>
  async ({ idRecipient, pageNumber, pageSize, orderBy, orderDescending }) => {
    set(tableLoadingState, true)

    try {
      const search = await snapshot.getPromise(tableStateSerach)

      const searchParams = {
        ...search,
        pageNumber: pageNumber || search.pageNumber,
        pageSize: pageSize || search.pageSize,
        orderDescending:
          orderBy === search.orderBy
            ? !search.orderDescending
            : search.orderDescending,
        orderBy: orderBy || search.orderBy,
      }

      const { Counters } = await getRecipientMessagesTotalCountersAction(
        idRecipient,
        searchParams.pageSize,
        searchParams.pageNumber,
        searchParams.orderBy,
        searchParams.orderDescending,
        ['AT', 'CT'],
      )

      set(tableStateResult, (prev) => ({
        ...prev,
        items:
          Counters.TotalItems > 0
            ? Counters.TotalCounters.filter((f) => f.IdMessage > 0)
            : [],
        totalItems: Counters.TotalItems,
      }))

      loadTrendDetailsCallback({ set })(Counters)

      set(tableStateSerach, searchParams)
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, {
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
        status: 'error',
      })
    }

    set(tableLoadingState, false)
  }

export const laodTrendChartCallback =
  ({ set, snapshot, reset }) =>
  async (idRecipient) => {
    set(chartState, (prev) => ({
      ...prev,
      loading: true,
    }))
    try {
      // const [firstOpening, lastOpening] = await Promise.all([
      //   getRecipientEventsOpeningsAction(idRecipient, 1, 1, 'OpeningOrderbyDate', false),
      //   getRecipientEventsOpeningsAction(idRecipient, 1, 1, 'OpeningOrderbyDate', true)
      // ])

      const resp = await getChartDataAction(idRecipient, null, null, [
        'AT',
        'CT',
      ])

      set(chartState, (prev) => ({
        ...prev,
        dailyCounters: resp,
        loading: false,
      }))
    } catch (error) {
      set(chartState, (prev) => ({
        ...prev,
        loading: false,
      }))
      logAppError({ appError: error })
      set(pageState, {
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
        status: 'error',
      })
    }
  }

export const resetPageCallback =
  ({ reset }) =>
  async () => {
    reset(pageState)

    reset(chartState)
    reset(recipientState)
    reset(tableStateSerach)
    reset(tableStateResult)
    reset(tableLoadingState)
  }
